import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DealState } from 'types';

export const initialState: DealState = {
    loading: true,
    isAuthenticated: false,
    deals: null,
    pageSize: 10,
    currentPage: 1,
    totalCount: 0,
    largestDeals: null,
    highestActuals: null,
    lowestActuals: null,
    highestGrossers: null,
    quarterWiseData: null,
    ytdDealToSales: null,
    yearComparisonData: null,
    monthlyRealisation: null,
    selectedRow: null,
    selectedRowKey: [],
};

const dealsSlice = createSlice({
    name: 'deals',
    initialState,
    reducers: {
        setDealResponse: (state, { payload }: PayloadAction<any>) => {
            state.loading = false;
            state.deals = payload?.response ?? null;
            state.totalCount = payload?.totalCount ?? 0;
        },
        setCurrentPage: (state, { payload }: PayloadAction<any>) => {
            state.currentPage = payload;
        },
        setPageSize: (state, { payload }: PayloadAction<any>) => {
            state.pageSize = payload;
        },
        setLargestDeals: (state, { payload }: PayloadAction<any>) => {
            state.largestDeals = payload;
        },
        setHighestActuals: (state, { payload }: PayloadAction<any>) => {
            state.highestActuals = payload;
        },
        setLowestActuals: (state, { payload }: PayloadAction<any>) => {
            state.lowestActuals = payload;
        },
        setHighestGrossers: (state, { payload }: PayloadAction<any>) => {
            state.highestGrossers = payload;
        },
        setQuarterWiseData: (state, { payload }: PayloadAction<any>) => {
            state.quarterWiseData = payload;
        },
        setYTDDealToSales: (state, { payload }: PayloadAction<any>) => {
            state.ytdDealToSales = payload;
        },
        setYearComparisonData: (state, { payload }: PayloadAction<any>) => {
            state.yearComparisonData = payload;
        },
        setMonthlyRealisation: (state, { payload }: PayloadAction<any>) => {
            state.monthlyRealisation = payload;
        },
        setSelectedRow: (state, { payload }: PayloadAction<any>) => {
            state.selectedRow = payload;
        },
        resetSelectedRow: (state) => {
            state.selectedRow = null;
        },
        setSelectedRowKey: (state, { payload }: PayloadAction<any>) => {
            state.selectedRowKey = payload;
        },
        resetSelectedRowKey: (state) => {
            state.selectedRowKey = [];
        },
    },
});

export const {
    setDealResponse,
    setCurrentPage,
    setPageSize,
    setLargestDeals,
    setHighestActuals,
    setLowestActuals,
    setHighestGrossers,
    setQuarterWiseData,
    setYTDDealToSales,
    setYearComparisonData,
    setMonthlyRealisation,
    setSelectedRow,
    resetSelectedRow,
    setSelectedRowKey,
    resetSelectedRowKey,
} = dealsSlice.actions;

export default dealsSlice.reducer;
